import React, { ReactNode, CSSProperties } from "react";

interface DashedBorderProps {
  children?: ReactNode;
  dashLength: number;
  gapLength: number;
  borderWidth: number;
  borderColor: string;

  dashOffset?: number;
  borderRadius?: number;
  className?: string;
  style?: CSSProperties;
}

const DashedBorder: React.FC<DashedBorderProps> = React.memo(
  ({
    children,
    dashLength,
    gapLength,
    borderWidth,
    borderColor,
    dashOffset = 0,
    borderRadius = 0,
    className = "",
    style = {},
    ...props
  }) => {
    const dashArray = `${Math.max(dashLength, 1)}%2c ${Math.max(
      dashLength + gapLength,
      2
    )}`;
    const colorHex = borderColor.replace("#", "%23");

    const containerStyle: CSSProperties = {
      backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='${borderRadius}' ry='${borderRadius}' stroke='${colorHex}' stroke-width='${Math.max(
        borderWidth,
        1
      )}' stroke-dasharray='${dashArray}' stroke-dashoffset='${dashOffset}' stroke-linecap='square'/%3e%3c/svg%3e")`,
      borderRadius: `${borderRadius}px`,
      ...style,
    };

    return (
      <div className={className} style={containerStyle} {...props}>
        {children}
      </div>
    );
  }
);

export default DashedBorder;
